module.exports = __webpack_public_path__ + "static/media/CardImage.2286152d.png";